import loansRouting from './loansRouting/loansRouting';

import creditworthiness from './creditworthiness/creditworthiness';
import loansCatalog from './loansCatalog/loansCatalog';
import loansDetail from './loansDetail/loansDetail';
import loansSignUp from './loansSignUp/loansSignUp';
import myLoans from './myLoans/myLoans';
import loansRepayment from './loansRepayment/loansRepayment';
import needALoan from './needALoan/needALoan';
import wageAdvance from './wageAdvance/wageAdvance';

import 'angular-translate';
import 'angular-translate-loader-url';
import 'angular-translate-loader-partial';

let loansFeatures = angular.module('loans.features', [
  loansRouting,
  creditworthiness,
  loansCatalog,
  loansDetail,
  loansSignUp,
  myLoans,
  loansRepayment,
  needALoan,
  wageAdvance
])

  .name;

export default loansFeatures;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loans.features.js